import { LOGIN_PAGE_BASE_PATH } from 'src/constants';
import { STUDIO_REFERRER } from 'src/routes/onboarding/setup/constants';
import { UrlUtils } from 'src/utils';

export type BuildStudioLoginPathInput = {
  prompt?: string;
  workspaceTemplateId?: string;
  workspaceTemplateName?: string;
  next?: string;
};

/**
 * Canonical builder for the Studio login page (`/login?referrer=studio`).
 * `OnboardingLoginPage` renders the passwordless Studio login screen only when
 * the `referrer=studio` param is present, so routing helpers must go through
 * this rather than hand-building the URL. Mirrors `buildStudioSignupPath` so the
 * signup <-> login cross-navigation threads the same context params instead of
 * dropping the user into classic login.
 */
export const buildStudioLoginPath = ({
  prompt,
  workspaceTemplateId,
  workspaceTemplateName,
  next,
}: BuildStudioLoginPathInput = {}): string => {
  const params: Record<string, string> = {
    referrer: STUDIO_REFERRER,
  };

  if (prompt) {
    params.prompt = prompt;
  }
  if (workspaceTemplateId) {
    params.template_id = workspaceTemplateId;
    if (workspaceTemplateName) {
      params.template_name = workspaceTemplateName;
    }
  }
  if (next) {
    params.next = next;
  }

  return `${LOGIN_PAGE_BASE_PATH}?${UrlUtils.FormatUrlQueryToString(params)}`;
};
